import wrapWithProvider from './src/lib/redux/store'
export const wrapRootElement = wrapWithProvider
